import { createAction } from "@reduxjs/toolkit";
import { Notification } from "./models";

export namespace NotificationActions {
  export enum ActionTypes {
    setNotification = "Set Notification",
    clearNotification = "Clear Notification",
  }

  export const clearNotification = createAction(ActionTypes.clearNotification);

  export const setNotification = createAction<Notification, ActionTypes.setNotification>(
    ActionTypes.setNotification
  );

  export type ClearNotification = ReturnType<typeof clearNotification>;
  export type SetNotification = ReturnType<typeof setNotification>;

  export type Actions = ClearNotification | SetNotification;
}
